import { Injectable } from "@angular/core";
import { User, UserAccess } from 'src/app/services/userStore/user.model'

export interface moduleObject {
  name?: string;
  label?: string;
  value?: string;
  routeValue?: string;
  lazyLoad?: boolean;
  icon?: string;
  customIcon?: boolean;
  iconReference?: string;
  description?: string;
  showModule?: boolean;
  cssClass?: string;
  showFAQ?: boolean;
  hasAccess?: boolean;
  canRequestAccess?: boolean;
  useLink?: boolean;
  link?: string;
  showCheckIn?: boolean;
  modules?: moduleObject[];
}

/*
declare global {
  interface Date {
    stdTimezoneOffset(): number;
    isDstObserved(): boolean;
  }

  Date.prototype.stdTimezoneOffset = function () {
    var jan = new Date(this.getFullYear(), 0, 1);
    var jul = new Date(this.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  Date.prototype.isDstObserved = function () {
    return this.getTimezoneOffset() < this.stdTimezoneOffset();
  }
}
*/


@Injectable()
export class Globals {

  appVersion: string = "2.17.0";

  isTesting = false;

  //VANTAGEPOINT
  //apiURL_Internal_API: string = 'https://powerportal.qualuscorp.com:34447';

  apiURL_Internal_API: string = 'https://powerportal.qualuscorp.com:34446';

  //apiURL_Internal_API: string = 'http://localhost:58395/';

  //FOR TESTING
  apiURL_Internal_API_Test: string = 'https://powerportal.qualuscorp.com:34447';


  apiURL_LocalHost: string = 'http://localhost:58395/';

  redmineURL: string = "https://powerportal.qualuscorp.com:444/redmine/";
  //redmineURL: string = "https://powerportal.qualuscorp.com:444/redmine/"; //QUALUSCORP

  baseURL_Tableau = "https://tableaureporting.qualuscorp.com/trusted/";
  baseURL_Tableau_Invalid = "https://tableaureporting.qualuscorp.com/#";
  baseURL_Tableau_Temp = "https://tableaureporting.qualuscorp.com/";

  /*
  baseURL_Tableau = "https://tableaureporting.powergridengineering.com/trusted/";
  baseURL_Tableau_Invalid = "https://tableaureporting.powergridengineering.com/#";
  baseURL_Tableau_Temp = "https://tableaureporting.powergridengineering.com/";
  */

  //FOR TESTING
  //baseURL_Tableau = "https://tableaureportingtest.powergridengineering.com/trusted/";
  //baseURL_Tableau_Invalid = "https://tableaureportingtest.powergridengineering.com/#";
  //baseURL_Tableau_Temp = "https://tableaureportingtest.powergridengineering.com/";

  tableauShareOptions = "&:showShareOptions=false&:render=false";
  //tableauShareOptions = "&:showShareOptions=false";

  pgeTennetId = "90033487-bdcc-4274-8c96-80f9b090fa00";
  cepTennetId = "241879b3-4c2b-4fe2-bef6-84be6bb75e1a";

  //cep application id: bed17b30-7750-45be-97be-46312b563246
  //cep object id: f4716f37-2685-4540-a882-ee583b9a604f
  //cep login url: https://login.microsoftonline.com/241879b3-4c2b-4fe2-bef6-84be6bb75e1a/saml2
  //cep client secret: uc1Y-P-c0~Z4xj7OiNL63.tC7hHho6LkHg

  salesforceToken: string = "112233";


  //CHANGE TO FALSE FOR PRODUCTION  / TRUE FOR LOCALHOST TESTING
  PGE_TimeEntry_In_Development = false;
  timeEntry_Environment_Integration = false;

  //REMOVE AFTER TIME ENTRY HAS BEEN FULLY ROLLED OUT
  timeEntry_Show_Issue_Button = false; //true;

  //timeEntry_Testing_Issues_URL = "https://powerportal.powergridengineering.com:444/redmine/projects/beta-testcd ing-issues/issues/new";

  //timeEntry_Issues_URL = "https://powerportal.powergridengineering.com:444/redmine/projects/time-expense-items-log/issues/new";
  timeEntry_Issues_URL = "https://powerportal.qualuscorp.com:444/redmine/projects/time-expense-items-log/issues/new"; //QUALUSCORP

  //INTEGRATION CONFIGURATION
  projectSubstring_Length: number = 11;

  supportsServiceWorkers = false;

  maxFileUploadSize: number = 102400; // 102400;
  maxFileUploadSize_Bytes: number = 10240000;
  //maxFileUploadSize: number = 104857.6;
  //maxFileUploadSize_Bytes: number = 10485760;

  //UNCOMMENT FOR QUALUS BRANDING ROLL OUT
  brandColor_PGE: string = "#000000";
  brandColor_PGE_Hover: string = "#4f4f4f"; /*"#252525";*/
  brandColor_CEP: string = "#000000";
  brandColor_CEP_Hover: string = "#4f4f4f"; /*"#252525";*/


  //"linear-gradient(90deg, rgb(2, 0, 36) 0%, rgb(0, 255, 233) 70%, rgb(0, 255, 233) 75%, rgb(0, 75, 47) 100%)"
  brandColor_Qualus: string = "#000000";
  brandColor_Qualus_Hover: string = "#4f4f4f"; /*"#252525";*/

  brandColor_Qualus_Hover2: string = "#8d9090";
  brandColor_Qualus_Hover3: string = "#88dd4df";


  brandColor_Qualus_Alt1: string = "#004b2c"; //green
  brandColor_Qualus_Alt2: string = "#1d7c88"; //green
  brandColor_Qualus_Alt3: string = "#2bbebd"; //green
  brandColor_Qualus_Alt4: string = "#36eee4"; //teal


  brandColor_SideNav: string = "#000000";
  brandColor_SideNav_Hover: string = "#4f4f4f";
  brandColor_Custom_Header: string = "linear-gradient(90deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 40%, rgb(54,238,228) 78%, rgb(0, 75, 47) 90%, rgb(0, 75, 47) 100%)"
  //"linear-gradient(90deg, rgb(2, 0, 36) 0%, rgb(2, 0, 36) 40%, rgb(58,255,242) 78%, rgb(58,255,242) 78%, rgb(0, 75, 47) 90%, rgb(0, 75, 47) 100%)";

  //multi direction
  //background: linear-gradient(45deg, rgb(2, 0, 36) 25%, rgb(58, 255, 242) 50%, rgb(0, 75, 47) 75%);


  useCustomHeaderVariable: boolean = false;

  primaryColorBackground_Accordion: string = "#000000";
  primaryColorText_Accordion: string = "white";

  homeModule_Background: string = "white";
  homeModule_Background_Hover: string = "#000000"; // "#000000";
  homeModule_Border_Hover: string = "#000000";

  //show_celebration: boolean = false;
  /*
  homeModule_Background_Hover: string = "#004B2C"; // "#000000";
  homeModule_Border_Hover: string = "#36EEE4";
  */


  /*
  brandColor_PGE: string = "#7a232e";
  brandColor_PGE_Hover: string = "#520101";
  brandColor_CEP: string = "#7a232e";
  brandColor_CEP_Hover: string = "#520101";

  brandColor_Qualus: string = "#7a232e";
  brandColor_Qualus_Hover: string = "#520101";

  brandColor_Qualus_Hover2: string = "#8d9090";
  brandColor_Qualus_Hover3: string = "#88dd4df";
  */


  /*DARKEST TO LIGHTEST*/
  /*
  GOLDER GREEN 1 - #315341
  GOLDER GREEN 2 - #387e42
  GOLDER GREEN 3 - #6ba839
  GOLDER GREEN 4 - #a4cd2c

  */


  //COMMENT FOR QUALUS BRANDING ROLL OUT
  /*
  brandColor_PGE: string = "#f5831f";
  brandColor_PGE_Hover: string = "#ec6e00";
  brandColor_CEP: string = "rgb(174, 154, 111)";
  brandColor_CEP_Hover: string = "#a5894d";
  */

  default_Help_Dial_Bottom_Position_Visible = "2rem";

  getOnlineAuthHours: number = 48; //2 DAYS
  getOfflineAuthHours: number = 336; //14 DAYS

  //*****indexedDB VERSIONS*****//

  //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_EMPLOYEE_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts

  dbVersion_EMPLOYEE_INFO_DB: number = 1;
  dbVersion_INCIDENT_TRACKER_DB: number = 5;  //V2 CREATED 2-15-2026
  dbVersion_JSA_DB: number = 1;

  //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_LOCATION_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts

  dbVersion_POWER_FORMS_DB: number = 2;
  dbVersion_POWER_PORTAL_DB: number = 2;
  dbVersion_PROJECT_LOG_DB: number = 1;

  //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_PROJECT_DB_Qualus: number = 4; //PRIMARY dbVersion
  dbVersion_PROJECT_DB: number = 3; //DEPRECATED
  dbVersion_PROJECT_DB_CE: number = 1; //DEPRECATED

  //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SAFETY_INSPECTIONS_DB: number = 1; //PRIMARY dbVersion //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SAFETY_INSPECTIONS_CATEGORIES_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SAFETY_INSPECTIONS_SUB_CATEGORIES_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SAFETY_INSPECTIONS_QUESTIONS_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts

  //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SKILLS_ASSESSMENT_DB: number = 1; //PRIMARY dbVersion //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SKILLS_ASSESSMENT_CATEGORIES_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts
  dbVersion_SKILLS_ASSESSMENT_SKILLS_DB: number = 1; //STILL NEED TO UPDATED VERSION ON web-worker.worker.ts

  dbVersion_TIME_EXPENSE_DB: number = 3;
  dbVersion_NEW_PROJECT_REQUEST_DB: number = 1;


  dbVersion_ESTIMATES_DB: number = 1;


  brandBackground(userObject: User) {
    switch (userObject.brand) {
      case "pge":
        return this.brandColor_PGE;
        break;
      case "cePower":
        return this.brandColor_CEP;
        break;
      default:
        return this.brandColor_Qualus;
        break;
    }
  }

  placeHolderImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAMFBMVEXx8/XCy9K/yND09vfw8vTP1tzp7O/i5ure4+fO1dvJ0dfT2d/EzNPt7/Lb4OXo6+4FeM7UAAAFL0lEQVR4nO2c24KrIAxFLdha7///t0dxOlWDSiAKztnrbR4G6SoJBKHZA6zJYncgQeCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ocEKBEwqcUOCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ot3Oi1KMq64FnWTVq+EueWzlRquqKVn/J+/ezEfdyHydKPYtc62yF1m1Xymq5ixPVdDnx8eslf1eCVu7hRFXFppAfLW39kNJyByeqOTJirGTvRsbKDZyozsHIpKUQsZK8E1Vu55GTrKTuRL0ZRoyVLviZaTtRVctUMuaVOnCoJO1E1WwjxsorbGZO2Qk7br5WuhApKTvpfZWMy5WAoZKuk6b1NhI4VJJ10uRBSsas0ng+OlUnVaARw9NvqCTqRERJpt9eUtJ0IqPEN36SdNIIKRnIPeafFJ0Ep9c5mr+qTdFJ2CRMpLAn5fScqJeokrFWZkoRdaImwtpw2T9iSnnxuiDoRFXda6hK28JzWTA14ryBxKFlTT9iTlT1W57o3Lta96yED8krRieknCw/DDuEP1TnKBlgzMlCTtZDXr+8pIjOwitK5x7JOKFD3mukiE85ix45S5FxYll46prdiv8ekpsU19wv4kS9LV1ouQPlrPzKliIzTuw9YDYiVfgFSxFx8rR+wcyMomSX9HYpTjlFwonqrB3gBc/JyYQjRcRJYe8Ay4l9rMlLcVi8iTjp7Y/nOBHcMjngWEoi4+TUlcmKw9rnxHzCWMqeU/ltkB9JEZl3SusnYmwQn1fm2GgPeiOzZrM9WZfu/3/BNDznYATLOLENffep+JppeMZBMSZUF9N6ljFM7KF3qpTduBZyQj4W53XTiRsEm1L2dr2k9k9W9Rtjq2BrJj9Zyk7pI7bP9lw8kfH+4KIFLGF77Sa3R90Un0POvHNCcYzsLVMk9+2buni1bd9xjMSJHMPmjCz7zov/fidW5GQ7OS/2e8BoRrLtrBfXScTIMVLsk09cJxEjZ8I6+cR1EmG1tsRaDsZ0EjlyDL0leuxOpulD4JTALtfXORRbnqVO1LDOePdtpoclWPsqulL+wt0P0SNnxFKrrp2opmuXl+5OuHA3PSmByDGQ9ezSydYdM+ELd4YUIsdANnoWTva2RSUv3JlnJRE5I2RbY+6kee1+dTrrhC7cPTZeMUdivZnydaIc3tdqqWuI6USOYZlSfp0oxzVlJxNByUSOYZlSPk6cDzqEXy17JDTn/LBMKRlTSRZ4X2giep2zZnEwZHLiGjifFt6BTtKKHMMspUxO2BkvDzoDm1jkGGa7bsaJx0t9XfgrOfuMlhezwsc48RrKufvhyiXXHatg8T2Zkm0eHzluxO8W4pXHKljkXycBt3h9blFdeqyCx2fPOguLbn6qTWsBu+Czxs/CopsdP4kmkx+mcZ8FRrfuWUqSTSYT005keDucW4iXnzRhMg17iYacC6A0VyZzzIQs0pBrUrn22JoXY4Us0pDjaZMzb+dIMX6/Qi0dHSU0XHySz48heqSaOs60vsvlq2mtpzj9OCh/Trgjew7afgLar63d6ec2SmTZm37+UyV7048K+Gmkm7O10A/8aaSbY7sEr8rYvYoNnX4Sr3EuYJVpVc35Ccu/innZbryMJ1n4v9f4N9FZ39XPZ931GYzMGH9VPHYfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADp8Q9+nG9anuOrfAAAAABJRU5ErkJggg==";

  brandImage(userObject: User) {
    switch (userObject.brand) {
      case "pge":
        //return "Power-Grid-logo-R.png";
        //UNCOMMENT FOR QUALUS BRANDING ROLL OUT
        //        return "QualusLogo.png";
        return "QualusLogo-min.png";
        break;
      case "cePower":
        //return "CePowerlogo.png";
        //UNCOMMENT FOR QUALUS BRANDING ROLL OUT
        //return "QualusLogo.png";
        return "QualusLogo-min.png";
        break;
      default:
        //return "QualusLogo.png";
        return "QualusLogo-min.png";
        break;
    }
  }

  brandBackgroundSecondary(userObject: User) {
    switch (userObject.brand) {
      case "pge":
        return "";
        break;
      case "cePower":
        return "";
        //return "#ae9a6f";
        break;
      default:
        return "";
        break;
    }
  }

  //ARRAY HOLDER FOR ACTIVE MODULES
  activeModules = [];

  homeModulesArrayGroup = [
    {
      label: "Operations", value: "operations", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Resource for reporting quality incidents.", showModule: true, cssClass: "a",
      modules: [
        { label: "iTrak", value: "itrak", lazyLoad: true, icon: "icon-itrak-black", customIcon: true, iconReference: "custom", description: "This module is now part of a separate Safety app. Click to continue.", showModule: false, cssClass: "a", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Inspections", value: "safetyReporting", lazyLoad: true, icon: "fas fa-clipboard-check", customIcon: false, iconReference: "fa", description: "This module is now part of a separate Safety app. Click to continue.", showModule: false, cssClass: "c", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Hazard Assessment", value: "hazardAssessment", icon: "fas fa-clipboard-check", lazyLoad: true, customIcon: false, iconReference: "fa", description: "Submit your Hazard Assessments", showModule: false, cssClass: "d", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "EZ Inventory", value: "ezInventory", lazyLoad: false, icon: "fas fa-boxes", customIcon: false, iconReference: "fa", description: "EZ Inventory - Asset Tracking and Management", showModule: false, cssClass: "q", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: true, link: "https://halo.qualuscorp.com/portal/service?btn=73&itil_requesttype_id=3&categoryid=54&id=343", usageColor: "" },
        { label: "Time & Expense", value: "timeExpense", lazyLoad: true, icon: "fas fa-clock", customIcon: false, iconReference: "fa", description: "Submit Timesheets & Expenses", showModule: false, cssClass: "r", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "", showCheckIn: true },
        { label: "Time Sheet Validation", value: "timeSheetValidation", lazyLoad: true, icon: "fas fa-clock", customIcon: false, iconReference: "fa", description: "This Legacy Module is no longer Supported", showModule: false, cssClass: "h", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        //{ label: "Time Sheet Validation", value: "timeSheetValidation", lazyLoad: true, icon: "fas fa-clock", customIcon: false, iconReference: "fa", description: "(No Longer Supported) Validate your timesheet for errors.  Note, this legacy module does not include the latest timesheet rules.", showModule: false, cssClass: "h", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "" },

        { label: "Billable Hiring", value: "billableHiring", lazyLoad: true, icon: "fas fa-check", customIcon: false, iconReference: "fa", description: "Submit for potential New Hires to confirm Margin", showModule: false, cssClass: "l", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "Support", value: "support", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Resource for reporting quality incidents.", showModule: true, cssClass: "a",
      modules: [
        { label: "IT Tools", value: "ittools", lazyLoad: false, icon: "fas fa-headset", customIcon: false, iconReference: "fa", description: "Locked out of your computer? Get your bitlocker recovery key here.", showModule: false, cssClass: "f", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "Reports", value: "reports", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Resource for reporting quality incidents.", showModule: true, cssClass: "a",
      modules: [
        { label: "Reports", value: "reports", lazyLoad: true, icon: "fas fa-chart-bar", customIcon: false, iconReference: "fa", description: "Custom Reports and Income Statements", showModule: false, cssClass: "k", showFAQ: true, hasAccess: false, canRequestAccess: true, useLink: false, link: "", usageColor: "" },
        { label: "Report Builder", value: "reportBuilder", lazyLoad: true, icon: "fas fa-chart-bar", customIcon: false, iconReference: "fa", description: "Custom Report Builder", showModule: false, cssClass: "m", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Power Forms", value: "forms", lazyLoad: true, icon: "fa fa-power-off", customIcon: false, iconReference: "fa", description: "A module for designing & managing 'Powerful' digital forms", showModule: false, cssClass: "o", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "Development", value: "itrak", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Resource for reporting quality incidents.", showModule: true, cssClass: "a",
      modules: [
        { label: "JaredMation", value: "developerLog", lazyLoad: false, icon: "fas fa-check", customIcon: false, iconReference: "fa", description: "Submit and track Developer Project requests for custom reports, code bugs, new features and other automation items", showModule: false, cssClass: "m", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: true, link: this.redmineURL, usageColor: "" },
        { label: "Equipment Inventory", value: "equipmentInventory", lazyLoad: false, icon: "fas fa-warehouse", customIcon: false, iconReference: "fa", description: "Field Services - Equipment Inventory", showModule: false, cssClass: "g", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Estimates", value: "estimates", lazyLoad: true, icon: "fas fa-calculator", customIcon: false, iconReference: "fa", description: "Create Estimates", showModule: false, cssClass: "n", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Marketing Products", value: "marketingInventory", lazyLoad: true, icon: "fas fa-tshirt", customIcon: false, iconReference: "fa", description: "Order Marketing Items", showModule: false, cssClass: "j", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Mileage Tracker", value: "mileageTracker", lazyLoad: false, icon: "fas fa-tachometer-alt", customIcon: false, iconReference: "fa", description: "Track Your Mileage", showModule: false, cssClass: "n", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "Accounting", value: "accounting", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Accounting Modules.", showModule: true, cssClass: "a",
      modules: [
        { label: "Accounting", value: "accounting", lazyLoad: true, icon: "fas fa-money-bill-alt", customIcon: false, iconReference: "fa", description: "Accounting Home Page", showModule: false, cssClass: "s", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
        { label: "Unbilled Portal", value: "unbilled", lazyLoad: true, icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "Project Management / Accounting Portal for Unbilled Items", showModule: false, cssClass: "i", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "Billing", value: "billing", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Billing Modules.", showModule: true, cssClass: "a",
      modules: [
        { label: "Unbilled Portal", value: "unbilled", lazyLoad: true, icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "Project Management / Accounting Portal for Unbilled Items", showModule: false, cssClass: "i", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "Project Delivery", value: "projectManagement", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Project Delivery Home Page", showModule: false, cssClass: "a",
      modules: [
        { label: "Project Log", value: "projectLog", lazyLoad: true, icon: "fa fa-list", customIcon: false, iconReference: "fa", description: "Update project activities, log notes & Out of Scope items.", showModule: true, cssClass: "e", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },
    {
      label: "HR", value: "hr", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Resource for reporting quality incidents.", showModule: true, cssClass: "a",
      modules: [
        { label: "Skills Assessment", value: "skillsAssessment", lazyLoad: true, icon: "fa fa-list-alt", customIcon: false, iconReference: "fa", description: "Complete your individual technical skills assessment and/or manage your team’s assessments.", showModule: false, cssClass: "b", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", usageColor: "" },
      ], usageColor: ""
    },

  ]

  //fa fa-power-off
  //fa fa-arrow-right-arrow-left
  //fas fa-hand-holding-usd
  //fa fa-list-alt
  //fas fa-ballot-check
  //fa-wpforms

  homeModulesArray = [
    { label: "Observations", value: "observations", lazyLoad: true, icon: "fas fa-eye", customIcon: false, iconReference: "fa", description: "This module is now part of a separate Safety app. Click to continue.", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "iTrak", value: "itrak", lazyLoad: true, icon: "fas fa-bolt", customIcon: false, iconReference: "fa", description: "This module is now part of a separate Safety app. Click to continue.", showModule: false, cssClass: "a", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    // { label: "iTrak", value: "itrak", lazyLoad: true, icon: "icon-itrak", customIcon: true, iconReference: "custom", description: "Resource for reporting quality incidents.", showModule: false, cssClass: "a", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
    { label: "Skills Assessment", value: "skillsAssessment", lazyLoad: true, icon: "fa fa-list-alt", customIcon: false, iconReference: "fa", description: "Complete your individual technical skills assessment and/or manage your team’s assessments.", showModule: false, cssClass: "b", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Inspections", value: "safetyReporting", lazyLoad: true, icon: "fas fa-hard-hat", customIcon: false, iconReference: "fa", description: "This module is now part of a separate Safety app. Click to continue.", showModule: false, cssClass: "c", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Hazard Assessment", value: "hazardAssessment", icon: "fas fa-triangle-exclamation", lazyLoad: true, customIcon: false, iconReference: "fa", description: "Submit your Hazard Assessments", showModule: false, cssClass: "d", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "JSA", value: "jsa", icon: "fas fa-triangle-exclamation", lazyLoad: true, customIcon: false, iconReference: "fa", description: "This module is now part of a separate Safety app. Click to continue.", showModule: false, cssClass: "d", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    /*{
      label: "Project Log"
      , showAlert: true
      , alertMessage: "The Project Log module is now included in the 'Project Delivery' Module.  This tile will be removed in an upcoming release."
      , value: "projectManagement/projectLog", lazyLoad: true, icon: "fa fa-list", customIcon: false, iconReference: "fa", description: "Update Project Activities, Plan Scope Hours, Log Notes & Out of Scope items.", showModule: false, cssClass: "e", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: ""
    },
    */
    { label: "IT Tools", value: "ittools", lazyLoad: false, icon: "fas fa-headset", customIcon: false, iconReference: "fa", description: "Locked out of your computer? Get your bitlocker recovery key here.", showModule: false, cssClass: "f", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Equipment Inventory", value: "equipmentInventory", lazyLoad: false, icon: "fas fa-warehouse", customIcon: false, iconReference: "fa", description: "Field Services - Equipment Inventory", showModule: false, cssClass: "g", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    //{ label: "Time Sheet Validation", value: "timeSheetValidation", lazyLoad: true, icon: "fas fa-calendar-check", customIcon: false, iconReference: "fa", description: "Validate your timesheet for errors.  Note this legacy module does not include the latest timesheet rules.", showModule: false, cssClass: "h", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
    { label: "Time Sheet Validation", value: "timeSheetValidation", lazyLoad: true, icon: "fas fa-calendar-check", customIcon: false, iconReference: "fa", description: "This Legacy Module is No longer Supported", showModule: false, cssClass: "h", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: true },
    { label: "Marketing Products", value: "marketingInventory", lazyLoad: true, icon: "fas fa-tshirt", customIcon: false, iconReference: "fa", description: "Order Marketing Items", showModule: false, cssClass: "j", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Reports", value: "reports", lazyLoad: true, icon: "fas fa-chart-bar", customIcon: false, iconReference: "fa", description: "Custom Reports and Income Statements", showModule: false, cssClass: "k", showFAQ: true, hasAccess: false, canRequestAccess: true, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Billable Hiring", value: "billableHiring", lazyLoad: true, icon: "fas fa-comments-dollar", customIcon: false, iconReference: "fa", description: "Submit for potential New Hires to confirm Margin", showModule: false, cssClass: "l", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "JaredMation", value: "developerLog", lazyLoad: false, icon: "fas fa-check", customIcon: false, iconReference: "fa", description: "Submit and track Developer Project requests for custom reports, code bugs, new features and other automation items", showModule: false, cssClass: "m", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: true, link: this.redmineURL, modules: [], usageColor: "", hideDemo: true },
    { label: "Mileage Tracker", value: "mileageTracker", lazyLoad: false, icon: "fas fa-tachometer-alt", customIcon: false, iconReference: "fa", description: "Track Your Mileage", showModule: false, cssClass: "n", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Report Builder", value: "reportBuilder", lazyLoad: true, icon: "fas fa-folder-plus", customIcon: false, iconReference: "fa", description: "Custom Report Builder", showModule: false, cssClass: "m", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "Estimates", value: "estimates", lazyLoad: true, icon: "fas fa-calculator", customIcon: false, iconReference: "fa", description: "Create Estimates", showModule: false, cssClass: "n", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: true },
    { label: "Power Forms", value: "forms", lazyLoad: true, icon: "fas fa-file-invoice", customIcon: false, iconReference: "fa", description: "Submit, Manage and Create Digital Forms", showModule: false, cssClass: "o", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: false },
    { label: "EZ Inventory", value: "ezInventory", lazyLoad: false, icon: "fas fa-boxes", customIcon: false, iconReference: "fa", description: "EZ Inventory - Asset Tracking and Management", showModule: false, cssClass: "q", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: true, link: "https://halo.qualuscorp.com/portal/service?btn=73&itil_requesttype_id=3&categoryid=54&id=343", modules: [], usageColor: "", hideDemo: false },
    { label: "Time & Expense", value: "timeExpense", lazyLoad: true, icon: "fas fa-business-time", customIcon: false, iconReference: "fa", description: "Submit Timesheets & Expenses. Request PTO", showModule: false, cssClass: "r", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", showCheckIn: true, modules: [], usageColor: "", hideDemo: false },
    {
      label: "Accounting", value: "accounting", lazyLoad: true, icon: "fas fa-balance-scale", customIcon: false, iconReference: "fa", description: "Accounting Home Page", showModule: false, cssClass: "s", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [
        { label: "Batch Transfer", value: "accounting/apBatchTransfer", lazyLoad: true, icon: "fas fa-file-export", customIcon: false, iconReference: "fa", description: "Batch Transfer", showModule: false, cssClass: "i", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
      ], usageColor: "", hideDemo: false
    },
    {
      label: "Billing", value: "billing", lazyLoad: true, icon: "fas fa-money-check-alt", customIcon: false, iconReference: "fa", description: "Billing Home Page", showModule: false, cssClass: "t", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [
        { label: "Unbilled Portal", value: "billing/unbilled", lazyLoad: true, icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "Project Management / Accounting Portal for Unbilled Items", showModule: false, cssClass: "i", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
      ], usageColor: "", hideDemo: false
    },

    {
      label: "Project Delivery", value: "projectManagement", lazyLoad: true, icon: "fas fa-clipboard-check", customIcon: false, iconReference: "fa", description: "Project Delivery Home Page", showModule: false, cssClass: "t", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [
        { label: "Project Log", value: "projectManagement/projectLog", lazyLoad: true, icon: "fas fa-book", customIcon: false, iconReference: "fa", description: "Update Project Activities, Plan Scope Hours, Log Notes & Out of Scope items.", showModule: false, cssClass: "e", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
      ], usageColor: "", hideDemo: false
    },

    { label: "Chat Trainer", value: "aiChatTrainer", lazyLoad: true, icon: "fas fa-brain", customIcon: false, iconReference: "fa", description: "AI Chat Trainer", showModule: false, cssClass: "m", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: true },
    { label: "Scheduler", value: "scheduler", lazyLoad: true, icon: "fas fa-calendar", customIcon: false, iconReference: "fa", description: "Scheduler", showModule: false, cssClass: "n", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "", hideDemo: true },

    {
      label: "Engineering", value: "engineering", lazyLoad: true, icon: "fas fa-plug", customIcon: false, iconReference: "fa", description: "Engineering Home Page", showModule: false, cssClass: "s", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [
        { label: "SLD Processor", value: "engineering/eng-image-processor", lazyLoad: true, icon: "fas fa-file-waveform", customIcon: false, iconReference: "fa", description: "SLD Processor", showModule: false, cssClass: "i", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
        //{ label: "Report Builder", value: "engineering/eng-report-builder", lazyLoad: true, icon: "fas fa-file-waveform", customIcon: false, iconReference: "fa", description: "Report Builder", showModule: false, cssClass: "i", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], usageColor: "" },
      ], usageColor: "", hideDemo: false
    },

  ]

  accountingModulesArray = [
    { label: "AP Invoicing", value: "apInvoicing", lazyLoad: false, icon: "fa fa-book", customIcon: false, iconReference: "fa", description: "AP Invoicing.", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "AP Batch Transfer", value: "apBatchTransfer", lazyLoad: false, icon: "fas fa-file-export", customIcon: false, iconReference: "fa", description: "AP Batch Transfer", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "AP Invoice Download", value: "apInvoiceBulkDownload", lazyLoad: false, icon: "fa fa-download", customIcon: false, iconReference: "fa", description: "AP Invoices - Bulk Download.", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "AP Payment Import", value: "apPaymentImport", lazyLoad: false, icon: "fa fa-money-bill-wave", customIcon: false, iconReference: "fa", description: "AP Payment - Bulk Import.", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "ASJC", value: "asjc", lazyLoad: false, icon: "fas fa-sliders-h", customIcon: false, iconReference: "fa", description: "Update Employee Labor Cost for ASJC", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "Budget History", value: "budgetHistory", lazyLoad: false, icon: "fas fa-history", customIcon: false, iconReference: "fa", description: "Budget History Data", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "Labor Cost Spread", value: "laborJobCostSpread", lazyLoad: false, icon: "fa fa-money-check", customIcon: false, iconReference: "fa", description: "Update Employee Labor Cost for Posting", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "Timesheets Import", value: "timesheetsImport", lazyLoad: false, icon: "fas fa-file-import", customIcon: false, iconReference: "fa", description: "Import Deltek Timesheets Excel File", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    //{ label: "ASJC", value: 'asjc', lazyLoad: false, icon: "fas fa-sliders-h", customIcon: false, iconReference: "fa", description: "Adjust Salaried Job Cost", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
  ]

  engineeringModulesArray = [
    { label: "SLD Processor", value: "eng-image-processor", lazyLoad: false, icon: "fa fa-file-waveform", customIcon: false, iconReference: "fa", description: "SLD Processor", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    //{ label: "Report Builder", value: "eng-report-builder", lazyLoad: false, icon: "fa fa-file-waveform", customIcon: false, iconReference: "fa", description: "Report Builder", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    //{ label: "AP Batch Transfer", value: "apBatchTransfer", lazyLoad: false, icon: "fas fa-file-export", customIcon: false, iconReference: "fa", description: "AP Batch Transfer", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    //{ label: "AP Invoice Download", value: "apInvoiceBulkDownload", lazyLoad: false, icon: "fa fa-download", customIcon: false, iconReference: "fa", description: "AP Invoices - Bulk Download.", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    //{ label: "Labor Cost Spread", value: "laborJobCostSpread", lazyLoad: false, icon: "fa fa-money-check", customIcon: false, iconReference: "fa", description: "Update Employee Labor Cost for Posting", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
  ]

  adminModulesArray = [
    { label: "Access", value: "admin-access", lazyLoad: false, icon: "fas fa-lock", customIcon: false, iconReference: "fa", description: "Access", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "Automation", value: "automation", lazyLoad: false, icon: "fas fa-sync", customIcon: false, iconReference: "fa", description: "Automation", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "Configuration", value: "configuration", lazyLoad: false, icon: "fas fa-gear", customIcon: false, iconReference: "fa", description: "Configuration", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "Documentation", value: "documentation", lazyLoad: false, icon: "fas fa-file", customIcon: false, iconReference: "fa", description: "Documentation", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "FAQ", value: "faq", lazyLoad: false, icon: "fas fa-question", customIcon: false, iconReference: "fa", description: "FAQ", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "Users", value: "users", lazyLoad: false, icon: "fas fa-user", customIcon: false, iconReference: "fa", description: "User Management", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "Roles", value: "roles", lazyLoad: false, icon: "fas fa-users", customIcon: false, iconReference: "fa", description: "Role Management", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
    { label: "Toolbox", value: "adminToolbox", lazyLoad: false, icon: "fas fa-toolbox", customIcon: false, iconReference: "fa", description: "Toolbox Management", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], },
  ]

  billingModulesArray = [
    { label: "Unbilled Portal", value: "unbilled", lazyLoad: false, icon: "fas fa-money-bill-alt", customIcon: false, iconReference: "fa", description: "Project Management / Accounting Portal for Unbilled Items", showModule: false, cssClass: "a", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], module: "billing" },
    { label: "Subcontractor Expenses", value: "subcontractorExpenses", lazyLoad: false, icon: "fas fa-receipt", customIcon: false, iconReference: "fa", description: "Subcontractor Expenses", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [], module: "billing" },
  ]

  projectManagementModulesArray = [
    { label: "Project Log", value: "projectLog", lazyLoad: true, icon: "fas fa-book", customIcon: false, iconReference: "fa", description: "Update Project Activities, Plan Scope Hours, Log Notes & Out of Scope items.", showModule: false, cssClass: "e", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
    { label: "Project Setup", value: "newProjectRequest", lazyLoad: true, icon: "fa fa-list", customIcon: false, iconReference: "fa", description: "Create New Project from Salesforce Opportunity.", showModule: false, cssClass: "e", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", modules: [] },
  ]


  settingsModulesArray = [
    //{ label: "Users", value: "users", lazyLoad: true, icon: "fas fa-user", customIcon: false, iconReference: "fa", description: "User Management", showModule: false, cssClass: "a", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", openDialog: false },
    //{ label: "Roles", value: "roles", lazyLoad: true, icon: "fas fa-user", customIcon: false, iconReference: "fa", description: "Role Management", showModule: false, cssClass: "a", showFAQ: true, hasAccess: true, canRequestAccess: false, useLink: false, link: "", openDialog: false },
    //{ label: "FAQ", value: "faq", lazyLoad: true, icon: "fas fa-question", customIcon: false, iconReference: "fa", description: "Frequently Asked Questions", showModule: false, cssClass: "a", showFAQ: false, hasAccess: true, canRequestAccess: false, useLink: false, link: "", openDialog: true },
  ]

  sideMenuOptions = [
    //{ name: "Accounting", routeValue: "/home/accounting", showOption: true, hasAccess: true, value: "accounting" },
    { name: "Billing", routeValue: "/home/billing", showOption: true, hasAccess: true, value: "billing" },
    { name: "Billable Hiring", routeValue: "/home/billableHiring", showOption: true, hasAccess: true, value: "billableHiring" },
    { name: "Engineering", routeValue: "/home/engineering", showOption: true, hasAccess: true, value: "engineering" },
    { name: "Equipment Inventory", routeValue: "/home/equipmentInventory", showOption: true, hasAccess: true, value: "equipmentInventory" },
    { name: "Hazard Assessment", routeValue: "/home/hazardAssessment", showOption: true, hasAccess: true, value: "hazardAssessment" },
    { name: "Inspections", routeValue: "/home/safetyReporting", showOption: true, hasAccess: true, value: "safetyInspections" },
    { name: "IT Tools", routeValue: "/home/ittools", showOption: true, hasAccess: true, value: "itTools" },
    { name: "iTrak", routeValue: "/home/itrak", showOption: true, hasAccess: true, value: "itrak" },
    { name: "JSA", routeValue: "/home/jsa", showOption: false, hasAccess: false, value: "jsa" },
    { name: "Marketing Products", routeValue: "/home/marketingInventory", showOption: true, hasAccess: true, value: "marketingProducts" },
    { name: "Power Forms", routeValue: "/home/forms", showOption: true, hasAccess: true, value: "forms" },
    //{ name: "Project Log", routeValue: "/home/projectManagement/projectLog", showOption: true, hasAccess: true, value: "projectLog" },
    { name: "Project Delivery", routeValue: "/home/projectManagement", showOption: true, hasAccess: false, value: "projectManagement" },
    { name: "Reports", routeValue: "/home/reports", showOption: true, hasAccess: false, value: "reports" },
    { name: "Skills Assessment", routeValue: "/home/skillsAssessment", showOption: true, hasAccess: true, value: "skillsAssessment" },
    { name: "Time & Expense", routeValue: "/home/timeExpense", showOption: true, hasAccess: true, value: "timeExpense" },
    { name: "Time Sheet Validation", routeValue: "/home/timeSheetValidation", showOption: true, hasAccess: true, value: "timeSheetValidation" },
  ];


  //CEP MODULES
  CE_ShowProjectReporting = false;
  CE_ShowItrak = true;
  CE_ShowObservations = true;
  CE_ShowSafetyInspections = true;
  CE_ShowItTools = false;
  CE_ShowSkillsAssessment = true;
  CE_ShowDeltekMobile = false;

  CE_ShowJSA = true;
  CE_ShowAssetManagement = false;
  CE_ShowUnbilled = false;
  CE_ShowMarketingInventory = false;
  CE_ShowTimeSheetValidation = false;
  CE_ShowReporting = true;
  CE_ShowMileageTracker = false;
  CE_ShowBillableHiring = false;
  CE_ShowDeveloperLog = false;
  CE_ShowDocumentsRepo = true;
  CE_ShowAssessments = true;
  CE_ShowEZInventory = false;

  CE_ShowReportBuilder = false;
  CE_ShowEstimates = false;

  //INTEGRATION GO LIVE
  //CE_ShowTimeEntry = false;
  CE_ShowTimeEntry = true;

  CE_ShowAccounting = false;
  CE_ShowBilling = false;
  CE_ShowEngineering = false;

  //PGE MODULES
  PGE_ShowProjectReporting = true;
  PGE_ShowProjectManagement = true;

  PGE_ShowItrak = true;
  PGE_ShowObservations = true;
  PGE_ShowSafetyInspections = true;
  PGE_ShowItTools = false;
  PGE_ShowSkillsAssessment = true;
  PGE_ShowAssessments = true;

  PGE_ShowJSA = true;
  PGE_ShowUnbilled = false;
  //PGE_ShowTimeSheetValidation = true;
  PGE_ShowTimeSheetValidation = false;
  PGE_ShowBillableHiring = false;
  PGE_ShowReporting = true;
  PGE_ShowDocumentsRepo = true;
  PGE_ShowDeltekMobile = true;
  PGE_ShowEZInventory = true;


  PGE_ShowReportBuilder = false;
  PGE_ShowTimeEntry = true;




  //UNDER CONSTRUCTION
  PGE_ShowMileageTracker = false;
  PGE_ShowMarketingInventory = false;
  PGE_ShowAssetManagement = false;
  PGE_ShowDeveloperLog = false;
  PGE_ShowEstimates = false;
  PGE_ShowAccounting = false;
  PGE_ShowBilling = false;
  //Change LATER
  PGE_ShowEngineering = false;
  QUALUS_ShowChatTrainer = false;
  QUALUS_Scheduler = false;



  pgeFooterMessage = {
    // message: "Powering Our Future Through People, Process, and Passion",
    message: "",
    fontColor: this.brandColor_PGE
  }

  ceFooterMessage = {
    message: "",
    fontColor: this.brandColor_CEP
  }

  classReference = [
    { id: 0, class: "a" },
    { id: 1, class: "b" },
    { id: 2, class: "c" },
    { id: 3, class: "d" },
    { id: 4, class: "e" },
    { id: 5, class: "f" },
    { id: 6, class: "g" },
    { id: 7, class: "h" },
    { id: 8, class: "i" },
    { id: 9, class: "j" },
    { id: 10, class: "k" },
    { id: 11, class: "l" },
    { id: 12, class: "m" },
    { id: 13, class: "n" },
    { id: 14, class: "o" },
    { id: 15, class: "p" },
    { id: 16, class: "q" },
    { id: 17, class: "r" },
    { id: 18, class: "s" },
    { id: 19, class: "t" },
    { id: 20, class: "u" },
    { id: 21, class: "v" },
    { id: 22, class: "w" },
    { id: 23, class: "x" },
    { id: 24, class: "y" },
    { id: 25, class: "z" },
    { id: 26, class: "aa" },
  ];

  classReference_Groups = [
    { id: 0, class: "a" },
    { id: 1, class: "b" },
    { id: 2, class: "c" },
    { id: 3, class: "d" },
    { id: 4, class: "e" },
    { id: 5, class: "f" },
    { id: 6, class: "g" },
    { id: 7, class: "h" },
    { id: 8, class: "i" },
    { id: 9, class: "j" },
    { id: 10, class: "k" },
    { id: 11, class: "l" },
    { id: 12, class: "m" },
    { id: 13, class: "n" },
    { id: 14, class: "o" },
    { id: 15, class: "p" },
    { id: 16, class: "q" },
    { id: 17, class: "r" },
    { id: 18, class: "s" },
    { id: 19, class: "t" },
    { id: 20, class: "u" },
    { id: 21, class: "v" },
    { id: 22, class: "w" },
    { id: 23, class: "x" },
    { id: 24, class: "y" },
    { id: 25, class: "z" },
    { id: 26, class: "aa" },
  ];

  reportHomeModulesArray = [
    { label: "Financials", value: "financials", lazyLoad: true, icon: "fas fa-file-invoice-dollar", rightIcon: "fa fa-angle-right", customIcon: false, iconReference: "fa", description: "Financial Reports, including Income Statements", showModule: true, cssClass: "a", showFAQ: false, isReport: false, moduleSelected: false },
    { label: "Personnel Monitor", value: "personnelMonitor", lazyLoad: false, icon: "fa fa-users", rightIcon: "fa fa-angle-right", customIcon: false, iconReference: "fa", description: "Employee Head Count & New Hire Metrics", showModule: true, cssClass: "b", showFAQ: false, isReport: true, moduleSelected: false },
  ];

  Reporting_ShowFinancials_CE = false;
  Reporting_ShowPersonnelMonitor_CE = true;
  Reporting_ShowQuality_CE = true;

  Reporting_ShowFinancials_PGE = true;
  Reporting_ShowPersonnelMonitor_PGE = true;
  Reporting_ShowQuality_PGE = true;

  financialsHomeModulesArray = [
    { label: "PGE Consolidated", value: "income_consolidated", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "a", showFAQ: false },
    { label: "PGE Consolidated (New)", value: "income_consolidated_new", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement (New)", showModule: false, cssClass: "a", showFAQ: false },
    { label: "MN NE NE2", value: "income_mn_ne_ne2", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "b", showFAQ: false },
    { label: "MS MS2", value: "income_ms_ms2", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "c", showFAQ: false },
    { label: "SE", value: "income_se", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "d", showFAQ: false },
    { label: "SE2", value: "income_se2", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "e", showFAQ: false },
    { label: "Birmingham", value: "income_birmingham", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "f", showFAQ: false },
    { label: "Raleigh", value: "income_raleigh", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "g", showFAQ: false },
    { label: "Winter Springs", value: "income_winter_springs", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "h", showFAQ: false },
    { label: "NE3 SE3", value: "income_ne3_se3", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "i", showFAQ: false },
    { label: "El Dorado", value: "income_el_dorado", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "j", showFAQ: false },
    { label: "ENG FS Consolidated", value: "income_eng_fs_consolidated", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "k", showFAQ: false },
    { label: "IT", value: "income_it", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "l", showFAQ: false },
    { label: "Quality", value: "income_quality", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "m", showFAQ: false },
    { label: "Safety", value: "income_safety", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "n", showFAQ: false },
    { label: "Training", value: "income_training", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "o", showFAQ: false },
    { label: "Human Resources", value: "income_hr", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "p", showFAQ: false },
    { label: "Client Management", value: "income_client_management", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "q", showFAQ: false },
    { label: "Business Development", value: "income_business_development", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "r", showFAQ: false },
    { label: "Project Management", value: "income_project_management", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "s", showFAQ: false },
    { label: "Support Services", value: "income_corp_support_services", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "t", showFAQ: false },
    { label: "Corporate Admin", value: "income_corp_admin", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "u", showFAQ: false },
    { label: "Field Services Master", value: "income_field_services_master", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "v", showFAQ: false },
    { label: "Engineering Master", value: "income_engineering_master", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "w", showFAQ: false },
    { label: "Operations Master", value: "income_operations_master", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "x", showFAQ: false },
    { label: "Executive Master", value: "'income_executive_master':", icon: "fas fa-file-invoice-dollar", customIcon: false, iconReference: "fa", description: "PGE Consolidated Income Statement", showModule: false, cssClass: "y", showFAQ: false },
  ];



  personnelMonitorHomeModulesArray = [
    { label: "Personnel Monitor", value: "personnel_monitor", icon: "fa fa-users", customIcon: false, iconReference: "fa", description: "", showModule: false, cssClass: "a", showFAQ: false, includesParameters: true, parameterValue: "", tabAdminAccess: false },
  ];

  tableauReportOptions = [
    { value: "Income Statements", viewValue: "Income Statements" },
    { value: "Personnel Monitor", viewValue: "Personnel Monitor" },
  ]


  Financials_ShowPGEConsolidated_PGE = true;
  Financials_ShowPGEConsolidated_CE = false;

  updateSupportsServiceWorkers(value) {
    this.supportsServiceWorkers = value;
  }

  areServiceWorkersSupported() {
    if ('serviceWorker' in navigator) {
      return true;
    } else {
      return false;
    }
  }


  gradientOrder_1 = 'rgb(180,180,180)';
  gradientOrder_2 = 'rgb(182,182,182)';
  gradientOrder_3 = 'rgb(184,184,184)';
  gradientOrder_4 = 'rgb(186,186,186)';
  gradientOrder_5 = 'rgb(188,188,188)';
  gradientOrder_6 = 'rgb(190,190,190)';
  gradientOrder_7 = 'rgb(192,192,192)';
  gradientOrder_8 = 'rgb(194,194,194)';
  gradientOrder_9 = 'rgb(196,196,196)';
  gradientOrder_10 = 'rgb(198,198,198)';
  gradientOrder_11 = 'rgb(200,200,200)';
  gradientOrder_12 = 'rgb(202,202,202)';
  gradientOrder_13 = 'rgb(204,204,204)';
  gradientOrder_14 = 'rgb(206,206,206)';
  gradientOrder_15 = 'rgb(208,208,208)';
  gradientOrder_16 = 'rgb(210,210,210)';
  gradientOrder_17 = 'rgb(212,212,212)';
  gradientOrder_18 = 'rgb(214,214,214)';
  gradientOrder_19 = 'rgb(216,216,216)';
  gradientOrder_20 = 'rgb(218,218,218)';
  gradientOrder_21 = 'rgb(220,220,220)';
  gradientOrder_22 = 'rgb(222,222,222)';

  usageColorArray = [
    /*
    { value: 'rgb(180,180,180)' },
    { value: 'rgb(182,182,182)' },
    { value: 'rgb(184,184,184)' },
    { value: 'rgb(186,186,186)' },
    { value: 'rgb(188,188,188)' },
    { value: 'rgb(190,190,190)' },
    { value: 'rgb(192,192,192)' },
    { value: 'rgb(194,194,194)' },
    { value: 'rgb(196,196,196)' },
    { value: 'rgb(198,198,198)' },
    { value: 'rgb(200,200,200)' },
    { value: 'rgb(202,202,202)' },
    { value: 'rgb(204,204,204)' },
    { value: 'rgb(206,206,206)' },
    { value: 'rgb(208,208,208)' },
    { value: 'rgb(210,210,210)' },
    { value: 'rgb(212,212,212)' },
    { value: 'rgb(214,214,214)' },
    { value: 'rgb(216,216,216)' },
    { value: 'rgb(218,218,218)' },
    { value: 'rgb(220,220,220)' },
    { value: 'rgb(222,222,222)' },
    */

    { value: 'rgb(230,230,230)' },
    { value: 'rgb(231,231,231)' },
    { value: 'rgb(232,232,232)' },
    { value: 'rgb(233,233,233)' },
    { value: 'rgb(234,234,234)' },
    { value: 'rgb(235,235,235)' },
    { value: 'rgb(236,236,236)' },
    { value: 'rgb(237,237,237)' },
    { value: 'rgb(238,238,238)' },
    { value: 'rgb(239,239,239)' },
    { value: 'rgb(240,240,240)' },
    { value: 'rgb(241,241,241)' },
    { value: 'rgb(242,242,242)' },
    { value: 'rgb(243,243,243)' },
    { value: 'rgb(244,244,244)' },
    { value: 'rgb(245,245,245)' },
    { value: 'rgb(246,246,246)' },
    { value: 'rgb(247,247,247)' },
    { value: 'rgb(248,248,248)' },
    { value: 'rgb(249,249,249)' },
    { value: 'rgb(250,250,250)' },
    { value: 'rgb(251,251,251)' },


  ]

}

export const isMobile = true;
export const SCHEDULER_LICENSE_KEY = 'CC-Attribution-NonCommercial-NoDerivatives';
